// 第1张
const imgAll1 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642303762/a1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642844134/c1.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642303762/a1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642844134/c1.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725092256789/a1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725092748481/b1.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725093141263/uk1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725093604140/uk1.jpg',
    },
};
export const imgLocale1: any = {
    jp: imgAll1.JP,
    us: imgAll1.NA,
    ca: imgAll1.NA,
    br: imgAll1.NA,
    mx: imgAll1.NA,
    uk: imgAll1.UK,
    eu: imgAll1.EU,
    nl: imgAll1.EU,
    de: imgAll1.EU,
    fr: imgAll1.EU,
    it: imgAll1.EU,
    es: imgAll1.EU,
};
